import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconInfoCircle = props => (
  <SvgIcon {...props} viewBox="0 0 26.666 26.666">
    <path d="m11.999 20h2.6667v-8h-2.6667v8zm1.334-20c-7.3333 0-13.333 6-13.333 13.333 0 7.3333 6 13.333 13.333 13.333 7.3333 0 13.333-6 13.333-13.333 0-7.3333-6-13.333-13.333-13.333zm0 24c-5.8667 0-10.667-4.8-10.667-10.667 0-5.8667 4.8-10.667 10.667-10.667s10.667 4.8 10.667 10.667-4.8 10.667-10.667 10.667zm-1.3333-14.667h2.6667v-2.6667h-2.6667v2.6667z" />
  </SvgIcon>
);

export default IconInfoCircle;



// WEBPACK FOOTER //
// ./src/components/icons/IconInfoCircle.js